/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function NetworkIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="network"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9 5.5C9 4.395 9.895 3.5 11 3.5L13 3.5C14.105 3.5 15 4.395 15 5.5L15 7.5C15 8.605 14.105 9.5 13 9.5L11 9.5C9.895 9.5 9 8.605 9 7.5L9 5.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14.5 16.5C14.5 15.395 15.395 14.5 16.5 14.5L18.5 14.5C19.605 14.5 20.5 15.395 20.5 16.5L20.5 18.5C20.5 19.605 19.605 20.5 18.5 20.5L16.5 20.5C15.395 20.5 14.5 19.605 14.5 18.5L14.5 16.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 16.5C3.5 15.395 4.395 14.5 5.5 14.5L7.5 14.5C8.605 14.5 9.5 15.395 9.5 16.5L9.5 18.5C9.5 19.605 8.605 20.5 7.5 20.5L5.5 20.5C4.395 20.5 3.5 19.605 3.5 18.5L3.5 16.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6.5 14.5L12 9.5L17.5 14.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
